var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_444_7938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_444_7938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16797 17.5V14.9615C3.16797 13.9567 3.52922 13.0965 4.25172 12.381C4.97405 11.6655 5.8468 11.3078 6.86997 11.3078H16.216V10.0717C16.216 9.66758 16.076 9.327 15.796 9.05C15.5158 8.77317 15.1686 8.63475 14.7545 8.63475H10.9237C10.5117 8.63475 10.1636 8.77217 9.87922 9.047C9.59489 9.32183 9.45272 9.66192 9.45272 10.0673H8.30272C8.30272 9.35142 8.55605 8.74458 9.06272 8.24675C9.56939 7.74892 10.1846 7.5 10.9085 7.5H14.7545C15.4793 7.5 16.0932 7.74958 16.5962 8.24875C17.0992 8.74808 17.3507 9.35425 17.3507 10.0673V14.4135H17.3795C17.8141 14.4135 18.1985 14.2802 18.5325 14.0135C18.8663 13.7468 19.0332 13.4026 19.0332 12.9808V9.06725C19.0332 8.35425 19.2847 7.74808 19.7877 7.24875C20.2907 6.74958 20.9046 6.5 21.6295 6.5H22.168V7.63475H21.6295C21.2153 7.63475 20.8682 7.77217 20.5882 8.047C20.3081 8.32183 20.168 8.66192 20.168 9.06725V12.9808C20.168 13.7241 19.8943 14.3378 19.347 14.822C18.7996 15.306 18.1438 15.548 17.3795 15.548H17.3507V17.5H3.16797ZM4.30272 16.3652H16.216V12.4423H6.86997C6.15147 12.4423 5.54397 12.6878 5.04747 13.1788C4.55097 13.6699 4.30272 14.2642 4.30272 14.9615V16.3652Z",
    fill: "#A3A3A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIron);
export default __webpack_public_path__ + "static/media/iron.6b28fb0b370fa8929e3c05d198c4141d.svg";
export { ForwardRef as ReactComponent };